;(function () {
  'use strict'
  angular.module('contrast.security').constant('idleTimeoutInterval', {
    FIFTEEN_MINUTES: {
      label: '15 minutes',
      value: 15,
      translationId: 'detail_minutes_plural',
      translationVariable: 15
    },
    THIRTY_MINUTES: {
      label: '30 minutes',
      value: 30,
      translationId: 'detail_minutes_plural',
      translationVariable: 30
    },
    ONE_HOUR: {
      label: '1 hour',
      value: 60,
      translationId: 'detail_hours_singular',
      translationVariable: 1
    },
    TWO_HOURS: {
      label: '2 hours',
      value: 120,
      translationId: 'detail_hours_plural',
      translationVariable: 2
    }
  })
})()
